import { useEffect, useState } from "react";

export const useResponsiveWidth = (breakpoint: number = 1024): boolean => {
    const [isMobileOrTablet, setIsMobileOrTablet] = useState<boolean>(
        () => window.innerWidth <= breakpoint
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobileOrTablet(window.innerWidth <= breakpoint);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobileOrTablet;
};
